import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { PointOfInterest } from '@/__generated__/graphql';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { LocationTag, VIEW_IN_3D_LABEL, VIEW_IN_3D_TOOLTIP_LABEL } from '@/constants';
import { GenerateReport } from '../GenerateReport';
import { PointOfInterestNavigation } from '../PointOfInterestNavigation';
import { ReviewHeaderShell } from '../ReviewHeaderShell';
import { useReviewIn3D } from '../hooks/useReviewIn3D';
import { ActionMenu } from '../PointsOfInterest/SummaryCard/ActionMenu';
import { ReviewAction } from '../PointsOfInterest/SummaryCard/ReviewAction';
import { usePoiTemplateFields } from '../hooks/usePoiTemplateFields';
import { ReviewStatus } from '../PointsOfInterest/SummaryCard/ReviewStatus';
import { useFeatureFlag } from '@/hooks';

type Props = {
  currentPoi: PointOfInterest;
  onClose: () => void;
  onBack: () => void;
};

export const PoiReviewHeader = ({ currentPoi, onClose, onBack }: Props) => {
  const { handleViewIn3D } = useReviewIn3D({ pointOfInterest: currentPoi });
  const { templateOfSelectedPoi } = usePoiTemplateFields({ data: currentPoi });
  const isAITEngineer = useFeatureFlag('ait-engineer');
  const isAPIInspector = useFeatureFlag('api-inspector');
  return (
    <ReviewHeaderShell
      onClose={onClose}
      onBack={onBack}
      closeId={`${LocationTag.ReviewPanelPoiModal}-close-button`}
      closeAriaLabel="Close review panel"
      backAriaLabel="Back to POI list"
      leftContent={
        <>
          <PointOfInterestNavigation location={LocationTag.ReviewPanelPoiModal} />
          {isAPIInspector && (
            <ReviewAction
              pointOfInterest={currentPoi}
              templateOfSelectedPoi={templateOfSelectedPoi}
              location={LocationTag.ReviewPanelPoiModal}
            />
          )}
          {isAITEngineer && (
            <ReviewStatus
              pointOfInterest={currentPoi}
              templateOfSelectedPoi={templateOfSelectedPoi}
              location={LocationTag.ReviewPanelPoiModal}
            />
          )}

        </>
      }
      actions={
        <>
          <Tooltip title={VIEW_IN_3D_TOOLTIP_LABEL} placement="bottom" arrow>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AbyssIcon iconName="cube-secondary" size="md" />}
              onClick={handleViewIn3D}
              id={`${LocationTag.ReviewPanelPoiModal}-view-in-3d-button`}
            >
              {VIEW_IN_3D_LABEL}
            </Button>
          </Tooltip>

          <GenerateReport useSelectedComponent location={LocationTag.ReviewPanelPoiModal} />
          <ActionMenu
            pointOfInterest={currentPoi}
            location={LocationTag.ReviewPanelPoiModal}
            hide3DView
          />
        </>
      }
    />
  );
};
